import React from 'react';
import CrudTable, { ImageCell } from '../../components/admin/CrudTable';

export default function ManageBlog() {
  return (
    <CrudTable
      entity="blog"
      title="Bloq"
      defaults={{ title: '', content: '', image: '', order: 0 }}
      fields={[
        { key: 'title', label: 'Başlıq', type: 'text' },
        { key: 'content', label: 'Məzmun', type: 'textarea', rows: 12 },
        { key: 'image', label: 'Səkil', type: 'image' },
        { key: 'order', label: 'Sıra', type: 'number' },
      ]}
      listColumns={[
        { key: 'image', label: 'Səkil', render: ImageCell },
        { key: 'title', label: 'Başlıq' },
        { key: 'order', label: 'Sıra' },
      ]}
    />
  );
}
